import React from "react";
import { Route, Routes } from 'react-router-dom'
import AddJustifyJourney from "../pages/journey-control/add-justifys-jorney/AddJustifyJourney";
import DashJourney from "../pages/journey-control/dashboard-journey/DashJourney";
import GeneralJourney from "../pages/journey-control/general-journey/GeneralJourney";
import Holiday from "../pages/journey-control/holiday/Holiday";
import JustifyJourney from "../pages/journey-control/justifys-jorney/JustifyJourney";
import SingleJourney from "../pages/journey-control/single-journey/SingleJourney";




const JourneyControlRoutes = (props) => {
    return (
        <Routes>
            <Route
                exact
                path={"/journey/dashboard-journey"}
                element={<DashJourney token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
            <Route
                exact
                path={"/journey/general-journey-control"}
                element={<GeneralJourney token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
            <Route
                exact
                path={"/journey/single-journey-control"}
                element={<SingleJourney token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
            <Route
                exact
                path={"/journey/journey-justify"}
                element={<JustifyJourney token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
            <Route
                exact
                path={"/journey/add-journey-justify"}
                element={<AddJustifyJourney token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
            <Route
                exact
                path={"/journey/journey-holiday"}
                element={<Holiday token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
        </Routes>
    )
}

export default JourneyControlRoutes